module.exports = __webpack_public_path__ + "img/77cc810.png";